import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const CTAButton = ({ to, children, variant = "orange", className = "", ...props }) => {
  const base =
    "group inline-flex items-center gap-2 px-7 py-4 font-display font-bold uppercase tracking-wide text-sm rounded-none transition-colors duration-300";
  const styles =
    variant === "orange"
      ? "bg-orange text-white hover:bg-orange-hover"
      : variant === "teal"
      ? "bg-teal text-black hover:bg-teal-muted"
      : "border border-white/20 text-white hover:border-teal hover:text-teal";

  const inner = (
    <motion.span
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      className={`${base} ${styles} ${className}`}
    >
      {children}
      <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
    </motion.span>
  );

  if (to) return <Link to={to} {...props}>{inner}</Link>;
  return <button {...props}>{inner}</button>;
};
